import React from 'react'
import { FormInputType } from '../../types/components'
import { Input, Wrapper, ErrorMessage } from './styles'

const FormInput = ({
	label,
	type,
	name,
	handleChange,
	onEnterPress,
	errorMessage,
	isValid,
	value,
	showError = true,
	pattern,
	maxlength,
	marginTop,
	autofocus,
	inputmode,
}: FormInputType) => {
	const onInputChange = (
		e: React.ChangeEvent<HTMLInputElement>,
		triggerHandleChange = true
	) => {
		if (triggerHandleChange) {
			handleChange(e)
		}
	}

	return (
		<Wrapper width="92%" margin={marginTop ? marginTop : '41px'}>
			<Input
				// eslint-disable-next-line jsx-a11y/no-autofocus
				autoFocus={autofocus}
				onBlur={(e) => onInputChange(e, false)}
				type={type === 'date' ? 'text' : type}
				name={name}
				value={value}
				onChange={onInputChange}
				onKeyDown={onEnterPress}
				pattern={pattern}
				placeholder={label}
				autoComplete="off"
				maxLength={maxlength}
				inputMode={inputmode}
			/>

			{showError && errorMessage && !isValid && (
				<ErrorMessage>{errorMessage}</ErrorMessage>
			)}
		</Wrapper>
	)
}

export default FormInput
